import base from './base'
import posts from './posts'
import customer from './customer'
import upload from './upload'
import talent from './talent'
import user from './user'
import role from './role'
import manage from './manage'
import thirdyParty from './thirdyParty'
import EnterpriseInfo from './EnterpriseInfo'
import IndividualUser from './IndividualUser'
import PhotoAlbum from './PhotoAlbum'
import EmployeeInfo from './EmployeeInfo'
import PositionInfo from './PositionInfo'
import PublicTalent from './PublicTalent'
import ReserveTalentInfo from './ReserveTalentInfo'
import BlackListInfo from './BlackListInfo'
import ProjectInfo from './ProjectInfo'
import JobApplicationInfo from './JobApplicationInfo'
import OnboardingLog from './OnboardingLogInfo'   
import Statistical from './Statistical'



export default {
  base,
  posts,
  customer,
  upload,
  talent,
  user,
  role,
  manage,
  thirdyParty,
  EnterpriseInfo,
  PhotoAlbum,
  EmployeeInfo,
  PositionInfo,
  PublicTalent,
  ReserveTalentInfo,
  BlackListInfo,
  ProjectInfo,
  JobApplicationInfo,
  OnboardingLog,
  IndividualUser,
  Statistical
}
